<template>
  <div>
    <Card
      :bordered="false"
      :dis-hover="true"
    >
      <p slot="title">申报表格<span style="color:#ed3f14;">（申报前下列各表必填）</span></p>
      <a
        href="javascript:void(0)"
        style="margin-right: 50px;"
        @click="viewReport('rule')"
      >分公司奖金规则申报表</a>
      <a
        href="javascript:void(0)"
        style="margin-right: 50px;"
        @click="viewReport('restRule')"
      >分公司奖金剩余部分分配规则申报表</a>
      <a
        href="javascript:void(0)"
        @click="viewReport('task')"
      >业务员月度任务申报表</a>
    </Card>
    <Modal v-model="declareReportVisible" :title="declareReportTitle" width="98%" class="declare-report" :transfer="flowPosition==='detail'">
      <iframe :src="declareReportUrl" style="width:100%;height:700px;border:0"></iframe>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="fillDetailVisible" :title="declareReportTitle" width="98%" :mask-closable="false" :transfer="flowPosition==='detail'">
      <div v-if="fillTableType==='rule'">
        <commissionRuleDetail :flowDetail="flowDetail"></commissionRuleDetail>
      </div>
      <div v-if="fillTableType==='task'">
        <commissionTaskDetail :flowDetail="flowDetail"></commissionTaskDetail>
      </div>
      <div slot="footer">
        <Button @click="fillDetailVisible=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import CommissionRuleDetail from './commissionDetail/commissionRuleDetail'
import CommissionTaskDetail from './commissionDetail/commissionTaskDetail'
import { formatDate } from '@/lib/tool'
import requestUrls from '@/lib/reportUrls'

export default {
  name: 'commissionRuleExtra',
  components: {
    CommissionRuleDetail,
    CommissionTaskDetail
  },
  props: {
    flowDetail: {
      type: Object
    },
    flowPosition: {
      type: String,
      default: 'detail'
    }
  },
  data() {
    return {
      declareReportTitle: '',
      declareReportUrl: '',
      declareReportVisible: false,
      fillDetailVisible: false,
      fillTableType: ''
    }
  },
  methods: {
    viewReport(type) {
      if (this.flowDetail.area === '' || this.flowDetail.company === '' || this.flowDetail.time === '') {
        this.$Message.info('请确认时间、地区及分子公司')
        return
      }

      // 报表特殊时间要求传入
      let baseTime = formatDate(this.flowDetail.time)
      let time = baseTime.split(' ')[0].substr(0, 8) + '01'
      let startTime = baseTime.split(' ')[0].substr(0, 4) + '-01-01'
      let endTime = baseTime.split(' ')[0].substr(0, 4) + '-12-01'

      if (type === 'rule') {
        this.declareReportTitle = '分公司奖金规则申报表'
        this.fillTableType = 'rule'
        // this.declareReportUrl = 'http://192.168.168.205:8080/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5956%5D%5B91d1%5D%5B53d1%5D%5B653e%5D%5B89c4%5D%5B5219%5D%5B7533%5D%5B62a5%5D%5B8868%5D.cpt&op=write'
        this.fillDetailVisible = true
        return
      }
      if (type === 'restRule') {
        this.declareReportTitle = '分公司奖金剩余部分分配规则申报表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5269%5D%5B4f59%5D%5B90e8%5D%5B5206%5D%5B5206%5D%5B914d%5D%5B89c4%5D%5B5219%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&starttime=${startTime}&endtime=${endTime}`
      }
      if (type === 'task') {
        this.declareReportTitle = '业务员月度任务申报表'
        this.fillTableType = 'task'
        // this.declareReportUrl = 'http://192.168.168.205:8080/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B4e1a%5D%5B52a1%5D%5B5458%5D%5B6708%5D%5B5ea6%5D%5B4efb%5D%5B52a1%5D%5B7533%5D%5B62a5%5D%5B8868%5D.cpt'
        this.fillDetailVisible = true
        return
      }
      this.declareReportVisible = true
    },
  }
}
</script>
